import { axiosBase } from "./config";
import { processLayoutElementForEmoji } from "../components/Elements/TABLE/tableUtils";

export const MicrositeService = {
    GET_MICROSITE(userID, flimpID, sessionID) {
        return axiosBase.get(`f2020_get_flimp_data?u=${userID}&f=${flimpID}&sn=${sessionID}`);
    },
    POST_MICROSITE(data) {
        const fd = JSON.parse(data.fd)
        
        //Processes layout elements to convert emojis to Unicode in TEXT and TABLE elements
        fd.layout?.forEach(processLayoutElementForEmoji);
        fd.layoutList?.forEach(item => Array.isArray(item?.[1]) && item[1].forEach(processLayoutElementForEmoji));

        data.fd = JSON.stringify(fd);
        return axiosBase.post("f2020_save_flimp_data?", data)
    },
    POST_NEW_MICROSITE(data) {
        return axiosBase.post("f2020_create_flimp", data)
    },
    POST_MICROSITE_META_UPDATE: function (data) {
        return axiosBase.post("f2020_update_flimp", data)
    }
}